import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldDateComponent } from './form-field-date.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';


@NgModule({
  declarations: [
    FormFieldDateComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,

  ],
  exports: [ FormFieldDateComponent ]
})
export class FormFieldDateModule { }
